module.exports = __webpack_public_path__ + "img/apple-mail.png";